import axios from 'axios';

export const sendEmail = (
  agentData: any,
  toEmail: string,
  subject: string,
  mandant: string,
  riskCheckId: string,
  tariffId: string,
  documentsId: string[],
  sendAttachments: boolean,
  template_name: string
) => {
  const birthdate = localStorage.getItem('birthdate');
  const updatedData = {
    ...agentData,
    birthdate,
  };

  const tariffIdEncoded = encodeURIComponent(tariffId.replaceAll(';', '#'));

  return axios.post(
    `${
      process.env.REACT_APP_BASE_URL
    }/${mandant}/email/send/${riskCheckId}/${tariffIdEncoded}`,
    {
      data: updatedData,
      to: toEmail,
      subject,
      sendAttachments,
      documentsId,
      template_name,
    }
  );
};
